import styled from 'styled-components';
import { theme } from '../../../theme';
import { FnButtonIconTypes } from './constants';

export const ButtonBase = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  color: ${theme.colors.secondary};
  // To fix native styles
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;

  span {
    font-size: 1.078rem;
    margin-right: 0.385rem;
    display: inline-block;
    word-break: break-all;
  }

  :focus,
  :hover {
    outline: none;
  }

  &.folder-icon {
    span {
      svg {
        font-size: 1.385rem;
      }
      & + span {
        margin-left: 0.385rem;
      }
    }
  }
`;

export const ButtonText = styled(ButtonBase)`
  span {
    margin-right: 0.385rem;
    text-decoration: underline;
  }
`;

export const ButtonLinkWithIcon = styled(ButtonBase)`
  color: ${theme.colors.primary};
  span {
    margin-right: 0.385rem;
    text-decoration: underline;
  }
  path {
    fill: ${theme.colors.secondary};
  }
`;

export const BUTTONS: Record<FnButtonIconTypes, typeof ButtonBase> = Object.freeze({
  [FnButtonIconTypes.Default]: ButtonBase,
  [FnButtonIconTypes.Link]: ButtonText,
  [FnButtonIconTypes.LinkWithIcon]: ButtonLinkWithIcon
});
